import styled from 'styled-components'
import { alpha } from '@mui/material/styles'
import { margin } from 'styled-system'

export const Container = styled.div<{ $color: string; $background?: string }>(
  ({ theme, $color, $background, ...rest }) => ({
    display: 'flex',
    alignItems: 'center',
    minHeight: '78px',
    padding: theme.spacing(1.25, 1.5),
    border: `1px solid ${theme.palette.border}`,
    background: $background ? $background : alpha($color, 0.5),
    color: 'inherit',
    // color: theme.palette.common.white,
    fontSize: theme.fontSizes.default,
    borderRadius: theme.radii.default,
    ...margin({ theme, ...rest }),
  }),
)

export const Content = styled.div(() => ({
  paddingLeft: 10,
  flex: 1,
}))

export const Title = styled.div`
  font-weight: 500;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`

export const SmallText = styled.div(({ theme }) => ({
  fontSize: theme.fontSizes.small,
  margin: '0.5em 0 0',
  opacity: 0.9,
}))

export const IconWrapper = styled.div<{ $color: string }>(({ $color }) => ({
  color: $color,
}))
